import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=3112ff10&scoped=true"
import script from "./projects.ts?vue&type=script&lang=js&external"
export * from "./projects.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112ff10",
  null
  
)

export default component.exports